module.exports = __webpack_public_path__ + "img/hero-image.890a1195.png";